import styled from "styled-components";

export const Container = styled.div`
	position: relative;
	.MuiInputBase-root.MuiInputBase-formControl {
		padding-right: 140px !important;
	}
	.ClearableIcon {
		display: none;
		color: ${({ theme }) => theme.pantone2726C};
	}

	&:hover {
		.ClearableIcon {
			display: block;
		}
	}
`;

export const AreaCheckbox = styled.div`
	position: absolute;
	display: flex;
	top: 12px;
	right: 40px;
	margin: 0;
	justify-content: center;
	align-items: center;

	.MuiFormControlLabel-root {
		margin: 0;
	}

	.MuiCheckbox-root {
		padding: 0;
	}

	.MuiCheckbox-colorSecondary.Mui-checked {
		color: #fab01c;
	}
`;
